import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatScore(score) {
  if (score >= 90) return { label: 'Excellent', color: 'text-verify' };
  if (score >= 75) return { label: 'Good', color: 'text-verify' };
  if (score >= 60) return { label: 'Fair', color: 'text-warning' };
  return { label: 'Needs Work', color: 'text-destructive' };
}

export function getRiskLevelColor(level) {
  switch(level) {
    case 'low': return 'text-verify';
    case 'medium': return 'text-warning';
    case 'high': return 'text-destructive';
    default: return 'text-muted-foreground';
  }
}
